import { CancelSubscriptionReason } from './components/CancelSubscriptionReason';
import styles from './CancelSubscription.module.scss';
import { CancelSubscriptionDifferentPlan } from './components/CancelSubscriptionDifferentPlan';
import { useEffect, useState } from 'react';
import { ComplementaryOffer } from 'src/v2/pages/subscription/components/CancelSubscription/components/ComplementaryOffer';
import { LoadingOverlay } from 'src/pages/PaymentBetaPage/components/LoadingOverlay';
import { CancellationDone } from 'src/v2/pages/subscription/components/CancelSubscription/components/CancellationDone';
import { useGetUser, useSubscriptionPlans } from 'src/hooks';
import { useCancelOffers } from 'src/hooks';

export const CancelSubscriptionSteps = {
  DIFFERENT_PLAN: 0,
  COMPLEMENTARY_OFFER: 1,
  SELECT_REASON: 2,
  CANCELLATION_DONE: 3,
};

export const CancelSubscription = () => {
  const { isTeamsTier } = useGetUser();
  const { cancelOffers, isCancelOffersLoading } = useCancelOffers();
  const { isPlansLoadingFirstTime } = useSubscriptionPlans({});

  const initialStep = isTeamsTier
    ? CancelSubscriptionSteps.SELECT_REASON
    : cancelOffers?.complimentary_offer?.eligible
      ? CancelSubscriptionSteps.COMPLEMENTARY_OFFER
      : CancelSubscriptionSteps.SELECT_REASON;

  const [step, setStep] = useState<number>(initialStep);

  useEffect(() => {
    setStep(initialStep);
  }, [initialStep]);

  if (isCancelOffersLoading || isPlansLoadingFirstTime) {
    return <LoadingOverlay label="Loading..." />;
  }

  const renderStepContent = () => {
    switch (step) {
      case CancelSubscriptionSteps.DIFFERENT_PLAN:
        return <CancelSubscriptionDifferentPlan onChangeStep={setStep} />;
      case CancelSubscriptionSteps.COMPLEMENTARY_OFFER:
        return <ComplementaryOffer onChangeStep={setStep} />;
      case CancelSubscriptionSteps.SELECT_REASON:
        return <CancelSubscriptionReason onChangeStep={setStep} />;
      default:
        return (
          <CancellationDone
            cancellationDate={
              cancelOffers?.default_offer?.entitlement_end_time || undefined
            }
          />
        );
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.container}>{renderStepContent()}</div>
    </div>
  );
};
